// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__jWd+5","LoginButton":"Login_LoginButton__PzgMg","LoginAcademedia":"Login_LoginAcademedia__Z9F7X","WelcomeText":"Login_WelcomeText__gZycz"};